import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_INITIALIZE_CONNECTION_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_INITIALIZE_CONNECTION_REQUEST`;
export const INTELLIGENT_PHOTO_CAPTURE_INITIALIZE_CONNECTION_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_INITIALIZE_CONNECTION_SUCCESS`;
export const photoCaptureIntelligentInitializeDamageConnectionRequestAction = () => ({
    type: INTELLIGENT_PHOTO_CAPTURE_INITIALIZE_CONNECTION_REQUEST,
    payload: undefined
});
export const photoCaptureIntelligentInitializeDamageConnectionSuccessAction = (connectionId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_INITIALIZE_CONNECTION_SUCCESS,
    payload: { connectionId }
});
//# sourceMappingURL=photoCaptureIntelligentInitializeDamageConnectionAction.js.map